// import React from 'react'
import './ESICMonthlyReport.css'
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { initializePendingAttendance, getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getStates, fetchMonths, getDistrict, } from '../../../services/monthlyAttendanceService';
import { getEsicMonthlyReport } from '../../../services/salaryStructureService';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { capitalizeFirstLetter } from '../../../utils/validations';
const ESICMonthlyReport = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(null);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [esicData, setEsicData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);


    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = month && year;
    const [selected, setSelected] = useState('');


    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setEsicData([]);
            setHasFetched(false); // Reset fetch status
        }
    }, [state]);

    // Clear esic data and fetch status when any dropdown changes
    // useEffect(() => {
    //     const fetchProjects = async () => {
    //         try {

    //             const data = await getProjects();
    //             setProjectResponse(
    //                 data.map(pro => ({
    //                     value: pro.id,
    //                     label: pro.projectCode,
    //                 }))
    //             );
    //         } catch (error) {
    //             console.error('Error fetching projects:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
    //         }
    //     };
    //     if (!effectRan.current) {
    //         fetchProjects();
    //     }
    //     return () => {
    //         effectRan.current = true;
    //     }
    // }, [state, district, year]);


    // Clear esic data and fetch status when any dropdown changes
    useEffect(() => {
        setEsicData([]);
        setOriginalData([]);
        setHasFetched(false);
    }, [state, month, year]); // ✅ Add project to depende


    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setProject(null); // ✅ Clear project when state changes
                break;
            case 'district':
                setDistrict(value);
                setProject(null); // ✅ Clear project when district changes
                break;
            case 'month':
                setMonth(value);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };


    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const data = await getEsicMonthlyReport(month, year);
            setHasFetched(true);
            setEsicData(data);
        } catch (error) {
            console.error("Error fetching ESI Monthly Report:", error);
            alert("Failed to fetch report. Please try again.");
        }
    };


    const handleClear = () => {
        setDistrict('');
        setState('');
        setMonth('');
        setYear('');
        setProject('');
        setSelected('');
    }

    const gotoDashboard = () => {
        navigate('/dashboard');
    };


    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('ESIC  Report');

        // Define columns for the Excel sheet
        worksheet.columns = [
            { header: 'S. No.', key: 'serialNo', width: 10 },
            { header: 'IP Number (10 Digits)', key: 'esicNumber', width: 20 },
            { header: 'IP Name (Only alphabets and space)', key: 'employeeName', width: 30 },
            { header: 'No of Days for which wages paid/payable during the month', key: 'noOfDays', width: 40 },
            { header: 'Total Monthly Wages', key: 'totalMonthlyWages', width: 20 },
            {
                header: 'Reason Code for Zero working days (numeric only; provide 0 for all other reasons - Click on the link for reference)',
                key: 'reasonCodeForZeroWorking',
                width: 30
            },
            { header: 'Last Working Day', key: 'lastWorkingDay', width: 20 }
        ];

        // Set header styles
        worksheet.getRow(1).eachCell(cell => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF00FFFF' } // Set background color to red (FFFF0000)
            };
            cell.font = {
                bold: true,
                color: { argb: '000000' } // Set text color to white
            };
        });

        // Add rows to the worksheet
        esicData.forEach((row, index) => {
            worksheet.addRow({
                serialNo: index + 1,
                esicNumber: row.esicNumber || 'N/A',
                employeeName: row.employeeName || 'N/A',
                noOfDays: row.noOfDays || 'N/A',
                totalMonthlyWages: row.totalMonthlyWages || 'N/A',
                reasonCodeForZeroWorking: row.reasonCodeForZeroWorking || 'N/A',
                lastWorkingDay: row.lastWorkingDay || 'N/A'
            });
        });
        const monthName = monthOptions.find((m) => m.value === month)?.label || "Unknown";
        // Write Excel file to buffer
        const buffer = await workbook.xlsx.writeBuffer();

        // Save the file
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `4Gid_ESI_MC_${monthName}_${year}.xlsx`);
    };


    return (
        <div className="monthly-esic-container">
            <div className="monthly-esic-box">
                <h2 className="monthly-esic-heading">ESIC  Report</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}>
                    {/* <div className="monthly-esic-maincontainer">
                        <div className="monthly-esic-container-part">
                            <div className={`monthly-esic-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="monthly-esic-container-part">
                            <div className={`monthly-esic-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label>District </label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div> */}
                    <div className="monthly-esic-maincontainer">
                        <div className="monthly-esic-container-part">
                            <div className={`monthly-esic-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="monthly-esic-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}
                                />
                                <label> <span className="required">*</span>Year </label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>
                        <div className="monthly-esic-container-part">
                            <div className={`monthly-esic-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Month </label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>
                    </div>
                    {/* <div className="monthly-esic-maincontainer">

                        <div className="monthly-esic-container-part">
                            <div className={`monthly-esic-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                <Select
                                    name="project"
                                    options={projectResponse}
                                    value={projectResponse.find(opt => opt.value === project) || null}
                                    onChange={option => handleInputChange(option, 'project')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span>Project </label>
                                {errors.project && <div className="error-message">{errors.project}</div>}
                            </div>
                        </div>
                        <div className="monthly-esic-container-part">

                        </div>
                    </div> */}
                    <div className="monthly-esic-btn-div">
                        <button
                            type="submit"
                            className="monthly-esic-btn"
                            disabled={!isFetchDataEnabled}
                        >
                            Fetch Data
                        </button>
                    </div>
                </form>
            </div>
            {hasFetched && (
                <div className="esic-table-container">
                    <button onClick={exportToExcel} className='excel-btn'>Export to Excel</button>
                    <table className="esic-table">
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>IP Number (10 Digits)</th>
                                <th>IP Name( Only alphabets and space )</th>
                                <th>No of Days for which wages paid/payable during the month</th>
                                <th>Total Monthly Wages</th>
                                <th> Reason Code for Zero workings days(numeric only; provide 0 for all other reasons- Click on the link for reference)</th>
                                <th> Last Working Day ( Format DD/MM/YYYY  or DD-MM-YYYY) </th>

                            </tr>
                        </thead>
                        <tbody>
                            {esicData.length === 0 ? (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center', padding: '10px' }}>No data available</td>
                                </tr>
                            ) : (
                                esicData.map((row, index) => {

                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{row.esicNumber || 'N/A'}</td>
                                            <td>{row.employeeName || 'N/A'}</td>
                                            <td>{row.noOfDays || '0'}</td>
                                            <td>{row.totalMonthlyWages || '0'}</td>
                                            <td>{row.reasonCodeForZeroWorking}</td>
                                            <td>{row.lastWorkingDay}</td>

                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>


                </div>
            )}
        </div>
    );
};

export default ESICMonthlyReport;